import React from 'react';
import { ComponentWrapper } from '../../ComponentWrapper';
import { PageSplitPanelResizable } from './PageSplitPanelResizable';
import { PageSplitPanelFlex } from './PageSplitPanelFlex';
import './PageSplit.scss';
import { usePageSplit, usePageSplitClasses } from '../hooks';
import { PageSplitDivider } from './PageSplitDivider';
export const PageSplit = ({ firstSplit, secondSplit, className: optionalClassName, splitType, initialSize, minSize, }) => {
    const { splitPaneRef, size, setSize, onMouseDown, onTouchStart, onMouseUp } = usePageSplit({ initialSize, minSize, splitType });
    const { pageSplit } = usePageSplitClasses(optionalClassName, splitType);
    return (React.createElement("div", { className: pageSplit, ref: splitPaneRef },
        React.createElement(PageSplitPanelResizable, { type: splitType, size: size, setSize: setSize },
            React.createElement(ComponentWrapper, { component: firstSplit })),
        React.createElement(PageSplitDivider, { className: optionalClassName, splitType: splitType, onMouseDown: onMouseDown, onTouchStart: onTouchStart, onMouseUp: onMouseUp }),
        React.createElement(PageSplitPanelFlex, { splitType: splitType, parentRef: splitPaneRef, firstSplitSize: size },
            React.createElement(ComponentWrapper, { component: secondSplit }))));
};
//# sourceMappingURL=PageSplit.js.map